import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SidebarMenu from "../../../Components/SidebarMenu";
import api from "../../../Services/api";
import { Page } from "../../SignedOut/Cadastro/styles";
import { PageTitle } from "../Creditos/styles";
import { Info } from "../PacienteUnico/styles";
import ReactLoading from "react-loading";
import { toast } from "react-toastify";
import { useHistory } from "react-router";
import PageContainer from "../../../Components/PageContainer";
import InfosMedico from "../../../Components/InfosMedico";
import BlockButton from "../../../Components/BlockButton";

export default function PrestadorUnico() {
  const { id } = useParams();
  const [prestador, setPrestador] = useState([]);
  const [loading, setLoading] = useState(true);
  const [requestDone, setRequestDone] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState(false);

  const history = useHistory();

  async function handleStatusChange(id, novoStatus) {
    setLoadingStatus(true);
    try {
      await api.patch(`/usuario/alterar_status/${id}`, { ST_usuario: novoStatus });
      console.log(handleStatusChange);
      const statusText = novoStatus === "SUSPENSO" ? "bloqueado" : "desbloqueado";
      const showToastMessage = () => {
        toast.success(`Prestador ${statusText} com sucesso`, {
          position: toast.POSITION.TOP_CENTER,
        });
      };
      showToastMessage();
      history.push("/prestadores");
    } catch (error) {
      const showToastMessageError = () => {
        toast.error(`Não foi possível alterar o status do prestador`, {
          position: toast.POSITION.TOP_CENTER,
        });
      };
      showToastMessageError();
      console.log(error);
    }
    finally {
      setLoadingStatus(false);
    }
  }

  useEffect(() => {
    const fetchRepositoriesData = async () => {
      setLoading(true);

      try {
        const response = await api.get(`/medicos/medicos/listar/${id}`);
        setPrestador(response.data);
        console.log(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
        setRequestDone(true);
      }
    };
    fetchRepositoriesData();
  }, [id]);

  if (loading || !requestDone) {
    return (
      <Page>
        <SidebarMenu />
        <PageContainer>
          <PageTitle>Prestador</PageTitle>
          <ReactLoading
            type="spin"
            color="#067187"
            height={"30px"}
            width={"30px"}
          />
        </PageContainer>
      </Page>
    );
  }

  if (prestador) {
    const isSuspenso = prestador.usuario?.ST_usuario === "SUSPENSO";

    return (
      <InfosMedico
        prestador={prestador}
        buttons={
          <div className="flex gap-2">
            {isSuspenso ? (
              <button
                disabled={loadingStatus}
                onClick={() => handleStatusChange(prestador.usuario.id_usuario, "ATIVO")}
                className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded disabled:opacity-50 disabled:cursor-not-allowed transition-all"
              >
                {loadingStatus ? "Aguarde..." : "Desbloquear"}
              </button>
            ) : (
              <BlockButton
                disabled={loadingStatus}
                onClick={() => handleStatusChange(prestador.usuario.id_usuario, "SUSPENSO")}
              />
            )}
          </div>
        }
      />
    );
  } else {
    return (
      <PageContainer>
        <Info>Erro ao carregar prestador</Info>
      </PageContainer>
    );
  }
}
